import apiConfig from "../api-config";

const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

const requestError = (message, code, card = false) => {
  const error = new Error(message);
  error.code = code;
  error.card = card;
  return error;
};

export const scanConfig = async (userId, credentials) => {
  if (!userId || !credentials) {
    throw requestError(
      "User ID and OCI credentials are required",
      "INVALID_INPUT"
    );
  }

  try {
    const token = sessionStorage.getItem("authToken");
    if (!token) {
      throw requestError("Authentication token is missing", "UNAUTHORIZED");
    }

    const response = await fetch(
      `${api_base_url}/api/${api_key}/post/${userId}/oci/scanConfig`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ credentials }),
      }
    );
    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw requestError(
        data.message || "OCI assessment request failed",
        data.code || "UNKNOWN_ERROR",
        data.meta?.showUpgradeCard || false
      );
    }
    return data;
  } catch (error) {
    console.error("Error during OCI scan:", error);
    throw requestError(
      error.message || "Network error",
      error.code || "NETWORK_ERROR",
      error.card || false
    );
  }
};

const runAuthorizedTargetScan = async (userId, endpoint, body) => {
  if (!userId) throw requestError("User ID is required", "INVALID_INPUT");
  const token = sessionStorage.getItem("authToken");
  if (!token) throw requestError("Authentication token is missing", "UNAUTHORIZED");
  const response = await fetch(
    `${api_base_url}/api/${api_key}/post/${userId}/oci/${endpoint}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ...body, authorizationConfirmed: true }),
    }
  );
  const data = await response.json();
  if (!response.ok || data.success === false) {
    throw requestError(
      data.message || data.error || "OCI target scan failed",
      data.code || "UNKNOWN_ERROR",
      data.meta?.showUpgradeCard || false
    );
  }
  return data;
};

export const scanOciIp = (userId, ip) =>
  runAuthorizedTargetScan(userId, "scanIp", { ip });

export const scanOciUrl = (userId, url) =>
  runAuthorizedTargetScan(userId, "scanUrl", { url });
